import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import { ElementDefinition, HeroElement } from "@easy-email-pro-core/typings";
import { BasicBlock } from "@easy-email-pro-core/components";
import React from "react";

const defaultData: ElementDefinition<HeroElement>["defaultData"] = {
  attributes: {
    "background-color": "#ffffff",
    "background-position": "center center",
    mode: "fixed-height",
    "vertical-align": "top",
  },
  data: {},
};

export const Hero = createBlock<HeroElement>({
  get name() {
    return t("Hero");
  },
  defaultData,
  type: BasicType.HERO,
  create: (payload) => {
    const defaultData: HeroElement = {
      type: BasicType.HERO,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.HERO,
  render(params) {
    return <BasicBlock params={params} tag="mj-hero" />;
  },
});
